"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _map = _interopRequireDefault(require("./map.js"));
var _deepGet = _interopRequireDefault(require("./_deepGet.js"));
var _toPath = _interopRequireDefault(require("./_toPath.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Invoke a method (with arguments) on every item in a collection.
var _default = exports.default = (0, _restArguments.default)(function (obj, path, args) {
  var contextPath, func;
  if ((0, _isFunction.default)(path)) {
    func = path;
  } else {
    path = (0, _toPath.default)(path);
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return (0, _map.default)(obj, function (context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = (0, _deepGet.default)(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
});